import { render, staticRenderFns } from "./TeacherInfo.vue?vue&type=template&id=a6df5836&scoped=true&"
import script from "./TeacherInfo.vue?vue&type=script&lang=js&"
export * from "./TeacherInfo.vue?vue&type=script&lang=js&"
import style0 from "./TeacherInfo.vue?vue&type=style&index=0&id=a6df5836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6df5836",
  null
  
)

export default component.exports